export default __webpack_public_path__ + "static/media/half_window.c678df4a.png";